/**
 * Created by Ning Jiang on 2/26/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {WildNudgeGameConfig} from "../WildNudgeGameConfig";

export interface IWildNudgeSymbolStates extends ISymbolStates {
    readonly noWin:ISymbolStateConfig;
    readonly attention:ISymbolStateConfig;
}

export class WildNudgeReelSymbol extends StateReelSymbol {

    private _noWinOverlay:PIXI.Graphics;
    private _dimOverlay:PIXI.Graphics;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === WildNudgeGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(() => this.addNoWinOverlay(), delay);
        }
    }

    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);

        if(transition.state.keyword != WildNudgeGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(() => this.removeNoWinOverlay(), delay);
        }
    }

    private addNoWinOverlay():void {
        if(!this._noWinOverlay) {
            this._noWinOverlay = this.createDarkOverlay(0.6);
        }

        this.addChild(this._noWinOverlay);
    }

    protected createDarkOverlay(alpha:number):PIXI.Graphics {
        const overlay = new PIXI.Graphics();
        overlay.beginFill(0x000000, alpha);
        if(this.stackedSymName!.isStacked) {
            overlay.drawRect(-GameConfig.instance.SYMBOL_WIDTH * 0.5, -(this.stackedSymName!.index + 0.5) * GameConfig.instance.SYMBOL_HEIGHT, GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.SYMBOL_HEIGHT * this.stackedSymName!.totalNum);
        } else {
            overlay.drawRect(-GameConfig.instance.SYMBOL_WIDTH * 0.5, -GameConfig.instance.SYMBOL_HEIGHT * 0.5, GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.SYMBOL_HEIGHT);
        }
        overlay.endFill();
        return overlay;
    }

    private removeNoWinOverlay():void {
        if(!this._noWinOverlay) {
            return;
        }

        this.removeChild(this._noWinOverlay);
    }

    public dim(duration:number, doStack:boolean):void {
        if(!this._dimOverlay) {
            this._dimOverlay = this.createDarkOverlay(0.8);
        }

        TweenLite.to(this._dimOverlay, duration, {alpha : 1});
        this.addChild(this._dimOverlay);
        // No need to move dimOverlay up when changing state? There is no state changing during dimming.

        if(doStack && this.stackedSymName!.isStacked) {
            this.stack!.symbols.forEach((symbol:StateReelSymbol | null, index:number) => {
                if(index != this.stackedSymName!.index && symbol != null) {
                    (<WildNudgeReelSymbol>symbol).dim(duration, false);
                }
            });
        }
    }

    public undim(duration:number, doStack:boolean):void {
        if(!this._dimOverlay) {
            return;
        }

        TweenLite.to(this._dimOverlay, duration, {alpha : 0, onComplete : () => this.removeChild(this._dimOverlay)});

        if(doStack && this.stackedSymName!.isStacked) {
            this.stack!.symbols.forEach((symbol:StateReelSymbol | null, index:number) => {
                if(index != this.stackedSymName!.index && symbol != null) {
                    (<WildNudgeReelSymbol>symbol).undim(duration, false);
                }
            });
        }
    }
}